import Enumerable from "linq";
import { AccessType, ConfigurationType, DateRangeType, DurationTimeframeTypeEnum, Scope } from "../../enums/DRCXEnums";
import { AccessPermission } from "../AccessPermission";
import { DRCXAvailableOptionalColumn } from "./DRCXAvailableOptionalColumn";
import { IDRCXConfigurationDTO } from "./DRCXConfigurationDTO";
import { DRCXConfigurationModelBase } from "./DRCXConfigurationModelBase";
import { IDRCXConfigurationSectionDTO } from "./DRCXConfigurationSectionDTO";
import { DRCXConfigurationSectionModel } from "./DRCXConfigurationSectionModel";

export class DRCXConfigurationModel extends DRCXConfigurationModelBase<DRCXConfigurationSectionModel> {
    public constructor(dto?: IDRCXConfigurationDTO) {
        super(dto);
    }

    public clone(): DRCXConfigurationModel {
        return new DRCXConfigurationModel(this.toDTO());
    }

    public createSection(section: IDRCXConfigurationSectionDTO | DRCXConfigurationSectionModel): DRCXConfigurationSectionModel {
        return new DRCXConfigurationSectionModel(section);
    }

    protected _toDTO(dto: IDRCXConfigurationDTO): IDRCXConfigurationDTO {
        return super._toDTO(dto);
    }

// This doesn't exist in SCADALynx    
// This is actually used in only one place, and that's useReportConfiguration query
    public static createDefault(configurationID: number, optionalColumns: Enumerable.ILookup<string, DRCXAvailableOptionalColumn>): DRCXConfigurationModel {
        const configuration = new DRCXConfigurationModel({
            id: configurationID,
            name: "New Report",
            configurationType: ConfigurationType.Report,
            access: AccessType.Private,
            userPermissions: new Array<AccessPermission>(),
            scope: Scope.User,
            created: new Date(),
            forAllGroups: false,
            overrideInstanceDates: false,
            timeframe: {
                durationTimeframeType: DurationTimeframeTypeEnum.MultipleTimeFrames,
                calculatedStartDateOffset: {
                    duration: -6,
                    rangeType: DateRangeType.Day
                },
                duration: {
                    duration: 7,
                    rangeType: DateRangeType.Day
                }
            },
            sections: [
                DRCXConfigurationSectionModel.createDefault(0, optionalColumns),
            ]
        });
    
        return configuration;
    }
}
